export default `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024">
    <path d="M1024 901.973v122.027h-1024v-122.027l341.333-219.307v-85.333q-31.573 0-58.453-63.573t-26.88-107.093v-170.667q0-105.813 75.093-180.907t180.907-75.093 180.907 75.093 75.093 180.907v170.667q0 43.52-26.88 107.093t-58.453 63.573v85.333z"></path>
</svg>
`;
